import { render } from "./IconChevronUp.vue?vue&type=template&id=d8d995d2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconChevronUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8d995d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8d995d2', __exports__)) {
    api.reload('d8d995d2', __exports__)
  }
  
  module.hot.accept("./IconChevronUp.vue?vue&type=template&id=d8d995d2", () => {
    api.rerender('d8d995d2', render)
  })

}


export default __exports__